import ListContext from '../../../../shared/components/utils/context/listContext';
import Selector from '../../atoms/images/languageSelector';
import Text from '../../atoms/text/playerLanguageModalText';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';

function PlayerLanguageModalItem({
  action,
  index,
  itemFocused,
  text,
}: {
  action: () => void;
  index: number;
  itemFocused: boolean;
  text: string;
}) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listFocused, listIndex } = useContext(ListContext);
  const [hovered, setHovered] = useState(false);
  const focused =
    (!enabled && listFocused && listIndex === index) || (enabled && hovered);
  return (
    <>
      <Text
        focused={itemFocused}
        onClick={action}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {focused ? <Selector /> : null}
        {text}
      </Text>
    </>
  );
}

export default PlayerLanguageModalItem;
